<template>
  <div class="author-articles-sort">
    <div class="author-articles-sort__panel">
      <h3 class="author-articles-sort__title title">
        Latest Articles
      </h3>
      <a-visibility hide :on="[$breakpoint.mobile]">
        <a-sort-by-latest-oldest
          class="author-articles-sort__sort-actions"
          @input="$emit('input', $event)"
        />
      </a-visibility>
    </div>

    <a-visibility show :on="[$breakpoint.mobile]">
      <a-sort-by-latest-oldest
        class="author-articles-sort__sort-actions"
        @input="$emit('input', $event)"
      />
    </a-visibility>
  </div>
</template>

<script>
import ASortByLatestOldest from 'shared/ASortByLatestOldest'

export default {
  name: 'AuthorArticlesSort',
  components: { ASortByLatestOldest }
}
</script>

<style lang="scss" scoped>
.author-articles-sort {
  .author-articles-sort__panel {
    padding: 0 20px;
    height: 60px;
    background: rgba($c--black, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    @include mobile {
      padding: 0 10px;
      height: 40px;
      margin-bottom: 10px;
    }
  }

  .author-articles-sort__sort-actions {
    @include mobile {
      display: block;
      margin-bottom: 20px;
    }
  }
}
</style>
